<ion-accordion-group
  value="transactionsDetail"
  (ionChange)="accordionGroupChange($event)"
>
  <ion-accordion value="transactionsDetail">
    <ion-item slot="header">
      <ion-row>
        <ion-col
          class="column-accordion-title"
          data-cy="column-accordion-title"
          size-md="10"
          size-sm="12"
          size-xs="12"
        >
          <ion-label class="accordion-title" data-cy="accordion-title">{{
            'i18n.payments.paymentConfirmation.failedTransactions' | translate
          }}</ion-label>
        </ion-col>

        <ion-col
          class="column-accordion-button-details"
          data-cy="column-accordion-button-details"
          size-md="2"
          size-sm="12"
          size-xs="12"
        >
          <ion-button
            data-cy="button-details"
            class="usf-outline-orange-button"
            >{{
              areDetailsShowing ? 'Hide details' : 'Show details'
            }}</ion-button
          >
        </ion-col>

        <ion-col
          size="12"
          class="column-accordion-subtitle"
          data-cy="column-accordion-subtitle"
        >
          <p class="accordion-subtitle" data-cy="accordion-subtitle">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <span
              >{{
                'i18n.payments.paymentConfirmation.failedTransactionSubtitle'
                  | translate
              }}
              <b>{{
                'i18n.payments.paymentConfirmation.failedTransactionContactNumber'
                  | translate
              }}</b></span
            >
          </p>
        </ion-col>
      </ion-row>
    </ion-item>
    <section class="ion-padding" slot="content">
      <ion-row
        class="header-row"
        *ngIf="
          platformService?.platformType ===
          platformService?.platformEnum.desktop
        "
      >
        <ion-col data-cy="transaction-failed-header-column-customer" size="3.1">
          {{ 'i18n.payments.transactionRow.customer' | translate }}</ion-col
        >
        <ion-col data-cy="transaction-failed-header-column-date" size="1.4">
          {{ 'i18n.payments.transactionRow.date' | translate }}</ion-col
        >
        <ion-col
          data-cy="transaction-failed-header-column-transaction"
          size="3"
        >
          {{ 'i18n.payments.transactionRow.transaction' | translate }}</ion-col
        >
        <ion-col data-cy="transaction-failed-header-column-amount" size="1.5">
          {{ 'i18n.payments.transactionRow.amount' | translate }}</ion-col
        >
        <ion-col data-cy="transaction-failed-header-column-reason" size="3">
          {{ 'i18n.payments.transactionRow.reason' | translate }}</ion-col
        >
      </ion-row>

      <ion-row
        *ngFor="let transaction of transactionsFailed; let i = index"
        class="transaction-row"
      >
        <ion-col size-lg="3" size-md="4" size-sm="12" size-xs="12">
          <div class="customer-content">
            <p [attr.data-cy]="'transaction-failed-row-customer-name-' + i">
              {{ transaction.customerName | titlecase }}
            </p>
            <p [attr.data-cy]="'transaction-failed-row-customer-number-' + i">
              #{{ transaction.customerNumber }}
            </p>
          </div>
        </ion-col>

        <ng-container
          *ngIf="
            platformService?.platformType ===
              platformService?.platformEnum.desktop;
            else orderToTouch
          "
        >
          <ion-col
            size="1.5"
            [attr.data-cy]="'transaction-failed-row-date-' + i"
          >
            <p>{{ transaction.issueDate | date: 'M/d/yyyy':'GMT' }}</p>
          </ion-col>
          <ion-col
            [attr.data-cy]="'transaction-failed-row-transactions-' + i"
            size="3"
          >
            <div class="customer-content">
              <ng-container
                *ngTemplateOutlet="
                  transactionInformation;
                  context: { transaction: transaction, i: i }
                "
              ></ng-container>
            </div>
          </ion-col>
          <ion-col size="1.5">
            <p [attr.data-cy]="'transaction-failed-row-amount-' + i">
              {{ transaction.amountDue | currency }}
            </p>
          </ion-col>
        </ng-container>

        <ng-template #orderToTouch>
          <ion-col
            size-md="4"
            size-sm="12"
            size-xs="12"
            [attr.data-cy]="'transaction-failed-row-group-' + i"
            class="transaction-group"
            [class.gri]="
              platformService?.platformType ===
              platformService?.platformEnum.mobile
            "
          >
            <div class="date">
              <p [attr.data-cy]="'transaction-failed-row-date-' + i">
                {{
                  (platformService?.platformType ===
                  platformService?.platformEnum.mobile
                    ? 'i18n.payments.transactionRow.issueDateCut'
                    : 'i18n.payments.transactionRow.date'
                  ) | translate
                }}:
                {{ transaction.issueDate | date: 'M/d/yyyy':'GMT' }}
              </p>
            </div>
            <div
              class="transaction"
              [attr.data-cy]="'transaction-failed-row-transaction-' + i"
            >
              <ng-container
                *ngTemplateOutlet="
                  transactionInformation;
                  context: { transaction: transaction, i: i }
                "
              ></ng-container>
            </div>

            <div
              *ngIf="
                platformService?.platformType ===
                platformService?.platformEnum.mobile
              "
              class="po"
            >
              <p [attr.data-cy]="'transaction-failed-row-po-' + i">
                {{ 'i18n.payments.transactionRow.custPo' | translate }} #:
                {{ transaction.customerPO }}
              </p>
            </div>
            <div class="amount">
              <p [attr.data-cy]="'transaction-failed-row-amount-' + i">
                <ng-container
                  *ngIf="
                    platformService?.platformType ===
                    platformService?.platformEnum.tablet
                  "
                >
                  {{ 'i18n.payments.transactionRow.amount' | translate }}:
                </ng-container>
                {{ transaction.amountDue | currency }}
              </p>
            </div>
          </ion-col>
        </ng-template>

        <ion-col
          [attr.data-cy]="'transaction-failed-row-reason-' + i"
          size-lg="3"
          size-md="4"
          size-sm="12"
          size-xs="12"
        >
          <span class="red-text">
            {{
              errorTexts[transaction.errorCode | lowercase] ||
                'i18n.payments.paymentConfirmation.genericFailedTransactionError'
                | translate: { value: transaction.errorCode }
            }}
          </span>
        </ion-col>
      </ion-row>
    </section>
  </ion-accordion>
</ion-accordion-group>

<ng-template #transactionInformation let-transaction="transaction" let-i="i">
  <p [attr.data-cy]="'transaction-failed-row-main-transaction-' + i">
    {{
      platformService?.platformType === platformService?.platformEnum.mobile
        ? transaction.transactionTypeStringShort
        : transaction.transactionTypeString
    }}
    {{
      ' #' +
        (!transaction.hasSecondaryTransaction
          ? transaction.transactionNumber
          : transaction.secondaryTransactionNumber)
    }}
  </p>
  <p
    *ngIf="transaction.hasSecondaryTransaction"
    [attr.data-cy]="'transaction-failed-row-secondary-transaction-' + i"
  >
    {{ 'i18n.payments.transactionRow.invoice' | translate }}:#{{
      transaction.transactionNumber
    }}
  </p>
</ng-template>
